import React, {useState} from 'react';
import { Modal, Result, WingBlank } from 'antd-mobile';
import PropTypes from 'prop-types';
import { getNickname } from '../../../helpers';
import _ from 'lodash';
import { Icon } from 'react-onsenui';
import axios from 'axios';
import { API_HOST } from '../../../config.env';

const init = () => {
    const stars = [];
    for(let i=0; i < 5; i++) {
        stars.push({key: i, icon: 'md-star-outline', color: '#888'})
    }

    return stars;
}

const RatingLiveModal = props => {
    const [star, setStar] = useState(init())
    const nickname = props.live && !_.isEmpty(props.live) && props.live.author ? getNickname(props.live.author.firstname, props.live.author.lastname, props.live.author.nickname) : '';
    return (
        <Modal
            popup
            visible={props.visible}
            onClose={props.onClose}
            animationType='slide-up'
            title={<h6 style={{...styles.common, marginBottom: 0, fontWeight: '700'}}>Ce live est terminé</h6>}
            footer={[{text: <div style={{color: '#d0021b', fontFamily: 'fff-equipe', fontSize: 14}}>Passer</div>, onPress: props.onClose}]}
        >
            <div style={{...styles.common, fontSize: 14, marginRight: 15, marginLeft: 15}}>Tu peux noter ton Live Scorer sur la qualité de son live</div>
            <Result 
                img={<div style={styles.thumb}>{ !_.isEmpty(props.live) && props.live.author && `${props.live.author.lastname.charAt(0)}${props.live.author.firstname.charAt(0)}`}</div>} 
                message={<span style={{...styles.common, fontSize: 12}}>{nickname}</span>} 
            />
            <WingBlank>
                {
                    star.map(s => <Icon onClick={() => {
                        const grades = init();
                        for(let i = 0; i <= s.key; i++) {
                            grades[i] = {key: i, icon: 'md-star', color: '#FFC107'}
                        }
                        setStar(grades);
                        rate(props.live['@id'], _.toNumber(s.key) + 1, props.access).then(() => props.onClose());

                    }} 
                    key={s.key} size={35} style={{color: s.color}} icon={s.icon} />)
                } 
            </WingBlank>
        </Modal>
    )
}

const rate = (live, value, access) => {
    return axios.post(`${API_HOST}${live}/add_grade`, {value}, {
        headers: {
            Accept: 'application/ld+json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access}`
        }
    })
}

const styles = {
    common: {
        color: '#004586',
        fontFamily: 'fff-equipe'
    },
    thumb: {
        width: '60px', 
        height: '48px',
        paddingBottom: '11px', 
        borderRadius: '50%', 
        backgroundColor: '#D0EBFF', 
        color: '#004586', 
        fontWeight: 700, 
        textAlign: 'center'
    }
}

RatingLiveModal.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func,
    live: PropTypes.object,
    access: PropTypes.string
}

export default RatingLiveModal;